// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@awc/Overrides/Widgets/ProductList/ProductListTable";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, ellipsis, mergeWithCss, sharedBadgeStyle } from "@awc/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        overflow: auto;
        width: 100%;
    `,
};

actionsStyles.gridContainer = {
    ...mergeWithCss(actionsStyles.gridContainer, {
        css: css`
            padding: 0;
        `,
    }),
    offsetCss: css`
        &&& {
            flex-wrap: nowrap;
        }
    `,
};

actionsStyles.dataTable = {
    mergeCss: true,
    css: css`
        td[class^="DataTableCellBase"] {
            vertical-align: top;
        }
    `,
};

actionsStyles.row = {
    evenRowCss: css`
        background: ${color("common.white")};
    `,
};

actionsStyles.gridContainer = {
    ...actionsStyles.gridContainer,
    gap: 8,
};

actionsStyles.leftColumnGridItem = {
    css: css`
        max-width: unset;
        flex-basis: unset;
        width: 98px;
        height: 98px;
        margin-right: 8px;

        ${({ hasCustomBadge }: any) => hasCustomBadge && "height: 138px;"}
    `,
};

actionsStyles.priceHeader = {
    alignX: "right",
};

actionsStyles.priceCell = {
    alignX: "right",
    css: css`
        & > * {
            align-items: flex-end;
        }
    `,
};

actionsStyles.actionsCell = {
    css: css`
        ${StyledButton} > ${TypographyStyle} {
            font-size: ${fontConfig.fontSize.xSmall}px;
            line-height: ${fontConfig.lineHeight.singleLinexxSmall};
        }
    `,
};

actionsStyles.productImageStyles = {
    customProductBadge: {
        textBadgeCss: {
            ...mergeWithCss(sharedBadgeStyle.badgeText, {
                css: css`
                    ${ellipsis(2)}
                `,
            }),
        },
    },
};
